import { render, staticRenderFns } from "./auther-list-drawer.vue?vue&type=template&id=27e0a6e8&scoped=true"
import script from "./auther-list-drawer.vue?vue&type=script&lang=js"
export * from "./auther-list-drawer.vue?vue&type=script&lang=js"
import style0 from "./auther-list-drawer.vue?vue&type=style&index=0&id=27e0a6e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0a6e8",
  null
  
)

export default component.exports